const reactModule = (Component, nodeList) => {
  const React = require('react');
  const { render } = require('react-dom');

  nodeList.forEach(node => render(<Component {...node.dataset} />, node));
};

export default [
  {
    name: 'backToTop',
    loader: () => import('./components/backToTop')
  },
  {
    name: 'scurveCard',
    loader: () => import('./components/scurveCard')
  },
  {
    name: 'spotlightCardSlider',
    loader: () => import('./components/spotlightCardSlider')
  },
  {
    name: 'testimonialBanner',
    loader: () => import('./components/testimonialBanner')
  },
  {
    name: 'videoCard',
    loader: () => import('./components/videoCard')
  },
  {
    name: 'alertBanner',
    loader: () => import('./components/alertBanner')
  },
  {
    name: 'latestEventsTablpdmobile',
    loader: () => import('./components/latestEventsTablpdmobile')
  },
  {
    name: 'dropdown',
    loader: () => import('./components/dropdown')
  },
  {
    name: 'search',
    loader: () => import('./components/search')
  },
  {
    name: 'formFields',
    loader: () => import('./components/formFields')
  },
  {
    name: 'tableOfContentsSummary',
    loader: () => import('./modules/tableOfContentsSummary')
  },
  {
    name: 'header',
    loader: () => import('./modules/header/index')
  },
  {
    name: 'header-lpd',
    loader: () => import('./modules/header-lpd/indexnew')
  },
  {
    name: 'header-v3',
    loader: () => import('./modules/header-v3/indexnew')
  },
  {
    name: 'stickyNavigationLpd',
    loader: () => import('./modules/stickyNavigationLpd')
  },
  {
    name: 'stickyNavigationBlogLpd',
    loader: () => import('./modules/stickyNavigationBlogLpd')
  },
  {
    name: 'stickyNavigationV2',
    loader: () => import('./modules/stickyNavigationV2')
  },
  {
    name: 'irSubNavigation',
    loader: () => import('./modules/irSubNavigation')
  },
  {
    name: 'heroSpotlight',
    loader: () => import('./modules/heroSpotlight')
  },
  {
    name: 'videoModal',
    loader: () => import('./modules/videoModal')
  },
  {
    name: 'verticalCardCarousel',
    loader: () => import('./modules/verticalCardCarousel')
  },
  {
    name: 'autoSliderCarousellpd',
    loader: () => import('./modules/autoSliderCarousellpd')
  },
  {
    name: 'careerTestimonialCarousel',
    loader: () => import('./modules/careerTestimonialCarousel')
  },
  {
    name: 'gartnerReviewCarousel',
    loader: () => import('./modules/gartnerReviewCarousel')
  },
  {
    name: 'businessProblemCarousel',
    loader: () => import('./modules/businessProblemCarousel')
  },
  {
    name: 'researchChartCarousel',
    loader: () => import('./modules/researchChartCarousel')
  },
  {
    name: 'noteworthyContentCarousel',
    loader: () => import('./modules/noteworthyContentCarousel')
  },
  {
    name: 'clientCarouselModuleLPD',
    loader: () => import('./modules/clientCarouselModuleLPD')
  },
  {
    name: 'threecardsacrossCareerslisting',
    loader: () => import('./modules/threecardsacrossCareerslisting')
  },
  {
    name: 'clientPortfolio',
    loader: () => import('./modules/clientPortfolio')
  },
  {
    name: 'epiForm',
    loader: () => import('./modules/epiForm')
  },
  {
    name: 'genericContent',
    loader: () => import('./modules/genericContent')
  },
  {
    name: 'columCardListing',
    loader: () => import('./modules/columCardListing')
  },
  {
    name: 'solutionsGrid',
    loader: () => import('./modules/solutionsGrid')
  },
  {
    name: 'interactiveClientcard',
    loader: () => import('./components/interactiveClientcard')
  },
  {
    name: 'careersHomeHeroV2ModuleCarousel',
    loader: () => import('./modules/careersHomeHeroV2ModuleCarousel')
  },
  {
    name: 'careerInteractivecard',
    loader: () => import('./components/careerInteractivecard')
  },
  {
    name: 'contentTabs',
    loader: () => import('./modules/contentTabs')
  },
  {
    name: 'tabModuleContainer',
    loader: () => import('./modules/tabModuleContainer')
  },
  {
    name: 'solutionIntegratedOfferingsTab',
    loader: () => import('./modules/solutionIntegratedOfferingsTab')
  },
  {
    name: 'solutionOfferingsTabs',
    loader: () => import('./modules/solutionOfferingsTabs')
  },
  {
    name: 'latestEventsModulelpd',
    loader: () => import('./modules/latestEventsModulelpd')
  },
  {
    name: 'solutionFeatured',
    loader: () => import('./modules/solutionFeatured')
  },
  {
    name: 'awardsTabModuleContainer',
    loader: () => import('./modules/awardsTabModuleContainer')
  },
  {
    name: 'newsroomTabs',
    loader: () => import('./modules/newsroomTabs')
  },
  {
    name: 'socialMediaHighlights',
    loader: () => import('./modules/socialMediaHighlights')
  },
  {
    name: 'locationsListing',
    loader: () => import('./modules/locationsListing'),
    render: reactModule
  },
  {
    name: 'partnerCardListingNew',
    loader: () => import('./modules/partnerCardListingNew'),
    render: reactModule
  },
  {
    name: 'partnerCardListingV2',
    loader: () => import('./modules/partnerCardListingV2'),
    render: reactModule
  },
  {
    name: 'insightsCenterCardListing',
    loader: () => import('./modules/insightsCenterCardListing'),
    render: reactModule
  },
  {
    name: 'facetListing',
    loader: () => import('./modules/facetListing'),
    render: reactModule
  },
  {
    name: 'contactUsForm',
    loader: () => import('./modules/contactUsForm')
  },
  {
    name: 'videoCarousel',
    loader: () => import('./modules/videoCarousel')
  },
  {
    name: 'thumbnailCarousel',
    loader: () => import('./modules/thumbnailCarousel')
  },
  {
    name: 'thumbnailCarouselV2',
    loader: () => import('./modules/thumbnailCarouselV2')
  },
  {
    name: 'blockquote',
    loader: () => import('./modules/blockquote')
  },
  {
    name: 'accordion',
    loader: () => import('./modules/accordion')
  },
  {
    name: 'historyCarousel',
    loader: () => import('./modules/historyCarousel')
  },
  {
    name: 'tabFacetedListing',
    loader: () => import('./modules/tabFacetedListing'),
    render: reactModule
  },
  {
    name: 'mediaCarousel',
    loader: () => import('./modules/mediaCarousel')
  },
  {
    name: 'featuredCarousel',
    loader: () => import('./modules/featuredCarousel')
  },
  {
    name: 'whyusCarouselModulelpd',
    loader: () => import('./modules/whyusCarouselModulelpd')
  },
  {
    name: 'glossaryList',
    loader: () => import('./modules/glossaryList')
  },
  {
    name: 'dualCtaHero',
    loader: () => import('./modules/dualCtaHero')
  },
  {
    name: 'subnavigation',
    loader: () => import('./modules/subnavigation')
  },
  {
    name: 'jumpLinkList',
    loader: () => import('./modules/jumpLinkList')
  },
  {
    name: 'earnings-release-table',
    loader: () => import('./modules/earningsReleaseTable')
  },
  {
    name: 'partner-card-listing',
    loader: () => import('./modules/partnerCardListing')
  },
  {
    name: 'audioPlayer',
    loader: () => import('./modules/audioPlayer/')
  },
  {
    name: 'subscribeCard',
    loader: () => import('./modules/subscribeCard')
  },
  {
    name: 'pageForms',
    loader: () => import('./modules/pageForms')
  },
  {
    name: 'solutions',
    loader: () => import('./modules/solutions')
  },
  {
    name: 'multiMediaCarousel',
    loader: () => import('./modules/multiMediaCarousel')
  },
  {
    name: 'careerInteractiveCardModuleCarousel',
    loader: () => import('./modules/careerInteractiveCardModuleCarousel')
  },
  {
    name: 'homepageBloomHero',
    loader: () => import('./modules/homepageBloomHero')
  },
  {
    name: 'cardListing',
    loader: () => import('./components/react/CardListing'),
    render: reactModule
  },
  {
    name: 'breadcrumbs',
    loader: () => import('./components/breadcrumbs')
  },
  {
    name: 'statsBlock',
    loader: () => import('./modules/statsBlock')
  },
  {
    name: 'awardCarouselModuleLPD',
    loader: () => import('./modules/awardCarouselModuleLPD')
  },
  {
    name: 'interactiveSolutioncard',
    loader: () => import('./components/interactiveSolutioncard')
  },
  {
    name: 'aiSearchLpd',
    loader: () => import('./modules/aiSearchLpd')
  },
  {
    name: 'buttonLpd',
    loader: () => import('./components/buttonLpd')
  },
  {
    name: 'solutionCarousel',
    loader: () => import('./modules/solutionCarousel')
  },
  {
    name: 'facetListingLpd',
    loader: () => import('./modules/facetListingLpd'),
    render: reactModule
  },
  {
    name: 'dividingBannerLpd',
    loader: () => import('./modules/dividingBannerLpd')
  },
  {
    name: 'reportsListing',
    loader: () => import('./modules/reportsListing')
  },
  {
    name: 'speakerCarousel',
    loader: () => import('./modules/speakerCarousel')
  },
  {
    name: 'recentBlogs',
    loader: () => import('./modules/recentBlogs')
  },
  {
    name: 'blogLandingPageRotatingHero',
    loader: () => import('./modules/blogLandingPageRotatingHero')
  }

];
